/**
 * Дата из отметки времени платформы.
 *
 * Платформа везде отдаёт unix-секунды, а Date ждёт миллисекунды — на этом
 * месте уже ошибались, получая даты из 1970 года. Одна функция на кабинет,
 * чтобы формат совпадал в наградах, покупках и билетах: «12 июня 2026».
 *
 * @param {number|null} timestamp секунды
 *
 * @returns {string} пустая строка, если отметки нет
 */
export const formatDate = (timestamp) => {
  const seconds = Number(timestamp);
  if (!Number.isFinite(seconds) || seconds <= 0) return "";

  return new Date(seconds * 1000).toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
